<template>
  <div class="view-more-layout sub-category">
    <portal-target name="filter-overlay-list" class="overlay-portal" />

    <div ref="contentsOverlay" class="view-more-contents">
      <div
        class="common-header"
        :style="{
          backgroundColor: tonal.gray[800],
        }"
      >
        <div class="top-section">
          <sub-category-menu
            v-if="hasSubCategory"
            :title="mainTitle"
            :options="subList"
            :close-fn="handleBack"
            @updateSubCategory="updateSubCategory"
          />
        </div>

        <div class="filter-wrapper" v-if="hasFilter">
          <div v-if="hasGenreFilter">
            <!-- 장르 -->
            <div class="orderby-area">
              <div class="inner">
                <genre-filter
                  :options="genres"
                  @selectedSubgenre="updateFilter"
                />
              </div>
            </div>
          </div>

          <!-- 정렬 -->
          <div v-if="hasOrderbyFilter">
            <div class="orderby-area">
              <div class="inner">
                <orderby-filter
                  :options="orderbys"
                  @selectedOrderby="updateFilter"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="view-more-component-container"
        data-scroll-element="true"
        :style="{
          'margin-top': hasFilter ? '' : '12px',
          height: hasFilter ? '42px' : '',
        }"
      >
        <infinite-scroll-cell-list
          v-if="contextList.length > 0"
          key="infinite-scroll-cell-list"
          :cell-list="contextList"
          :thumbnail-info="thumbnailInfo"
          :container-class-name="getContextListContainerClassName"
          @load-more="loadMore"
        />

        <div v-show="isEmpty" class="empty-cell-list">
          <div class="attention-mark-area">
            <empty-image></empty-image>
          </div>

          <div class="text-area">해당데이터가 없습니다.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VueSticky from 'vue-sticky'
  import { parseUrl, parse } from 'query-string'
  import { EventService } from '@/common/api/api.service'
  import { getBandTypeInfoByCellType } from '@/common/image.util'
  import { PATH_NAME_HOME } from '@/common/router.const'
  import EmptyImage from '@/assets/svg/common/img_empty.svg'
  import EventModelClass from '@/common/model/EventModelClass'
  import { isMobileDevice } from '@/common/util/ua'
  import { stringify } from '@/common/util/shared'
  import { tonal } from '@/constants/tonal'
  import { useHome } from '@/common/use/useHome'
  import { convertEventOnClick } from '@/common/converter/convert-event-on-click'
  import { ON_CLICK } from '@/common/event.const'
  import { EventBus } from '@/components/eventbus/EventBus'

  import InfiniteScrollCellList from '@/components/section/template/cell/InfiniteScrollCellList'

  import SubCategoryMenu from '@/components/category/Sub/Header/SubCategoryMenu'
  import GenreFilter from '@/components/category/Sub/Filter/Genre'
  import OrderbyFilter from '@/components/category/Sub/Filter/Orderby'

  export default {
    name: 'SubCategory',

    directives: {
      VueSticky,
    },

    components: {
      SubCategoryMenu,
      InfiniteScrollCellList,
      EmptyImage,
      GenreFilter,
      OrderbyFilter,
    },

    data() {
      return {
        tonal,
        currentEvent: null,
        selectedCategoryTitle: '',

        isEmpty: false,
        offset: 0,
        limit: 21,
        endOfList: false,

        listUrl: {},

        titleList: [],
        topButtonList: [],
        contextList: [],
        pageCount: [],
        thumbnailInfo: null,

        filterQueryMap: null,
        filterTitleMap: {},
        filterList: [],
        genres: [],
        orderbys: [],

        mainTitle: '',
        subList: null,
        subCategoryList: {
          _default: '',
          itemList: [],
        },
        isLoading: false,
        isFirstRender: true,
        thumbnailType: '',
      }
    },

    watch: {
      thumbnailInfo(newType, oldType) {
        this.thumbnailType = newType.type
      },
    },

    computed: {
      hasSubCategory() {
        return this.subList !== null
      },
      hasGenreFilter() {
        return (this.genres?.itemList?.length ?? 0) > 0
      },
      hasOrderbyFilter() {
        return (this.orderbys?.itemList?.length ?? 0) > 0
      },
      hasFilter() {
        return this.hasGenreFilter || this.hasOrderbyFilter
      },
      getContextListContainerClassName() {
        return `cell-list responsive cell-${this.thumbnailType}`
      },
      isMobileDevice() {
        return isMobileDevice()
      },
    },

    created() {
      const { mainCode, subCode } = this.$route.query

      this.setSubCategoryList(mainCode, subCode)
      this.initialize(mainCode, subCode)
    },

    methods: {
      async updateSubCategory(event) {
        if (!this.isUpdating) this.isUpdating = true
        if (!event) return

        const { mainCode } = this.$route.query
        const { subCode } = event

        const [onClick] = event.eventlist
        EventBus.$emit(ON_CLICK, onClick)

        await this.reset()

        if (this.isFirstRender) {
          this.isFirstRender = false
        }

        await this.initialize(mainCode, subCode)

        this.isUpdating = false
      },

      updateFilter({ selected, title, index }) {
        if (selected) {
          this.reset()

          this.filterTitleMap[index] = title
          this.filterQueryMap = { ...this.filterQueryMap, ...selected }

          const eventInstance = new EventModelClass(this.currentEvent)
          eventInstance.filter = this.filterQueryMap

          this.fetchEventData(eventInstance)
        }
      },

      async subCategoryFilter(fetchURL) {
        const { getCategorySubData } = useHome()
        const data = await getCategorySubData({
          category: this.$route.query.mainCode,
          subCategory: this.$route.query.subCode,
        })

        const { query } = parseUrl(fetchURL)

        if (data) {
          const { filter } = data?.layout
          this.filterObject = filter || {}
          this.filterList = this.filterObject.filterList || []

          if (Object.keys(this.filterTitleMap).length === 0) {
            this.filterList.forEach((filterItem, index) => {
              const filterItemList = filterItem.item_list || []
              filterItemList.forEach((item, itemIndex) => {
                const params = { [filterItem.key]: item.value }
                const key = Object.keys(params)[0]

                if (query[key] === params[key]) {
                  this.filterQueryMap = { ...this.filterQueryMap, ...params }
                  this.filterTitleMap[index] =
                    (filterItemList[itemIndex] &&
                      filterItemList[itemIndex].title) ||
                    ''
                }
              })
              if (this.selectedCategoryTitle) {
                filterItemList.forEach((filterItem) => {
                  if (filterItem.title === this.selectedCategoryTitle) {
                    this.filterTitleMap[index] = filterItem.title
                  }
                })
              }
            })
          }

          this.genres =
            this.filterList.find((filter) => filter.key === 'subgenre') || {}
          this.orderbys =
            this.filterList.find((filter) => filter.key === 'orderby') || {}
        }
      },

      async initEventInstance(apiUrl) {
        try {
          const eventInstance = new EventModelClass({
            url: decodeURIComponent(apiUrl),
          })
          const { url, query } = parseUrl(eventInstance.url)

          const routeQuery = {
            ...this.$route.query,
          }
          const finalQuery = { ...query }

          query.limit = 21

          if (!this.isFirstRender) {
            this.updateRouteKeepingMainAndSubCodeOnly()

            const updateRoutePath = `${this.$route.fullPath}&${stringify(query)}`
            this.$router.push({ path: updateRoutePath })
          } else {
            Object.keys(routeQuery).forEach((key) => {
              finalQuery[key] = routeQuery[key]
            })
          }

          eventInstance.url = `${url}?${stringify(finalQuery)}`
          this.currentEvent = eventInstance

          await this.fetchEventData(eventInstance)
        } catch (error) {
          throw new Error(error)
        }
      },

      async initialize(mainCode, subCode) {
        if (!mainCode || !subCode) return

        const { getCategorySubData, getFetchURL } = useHome()

        const data = await getCategorySubData({
          category: mainCode,
          subCategory: subCode,
        })

        if (data) {
          const fetchURL = await getFetchURL(data)
          await this.initEventInstance(fetchURL)
          await this.subCategoryFilter(fetchURL)
        }

        if (this.endOfList) {
          this.endOfList = false
        }
      },

      async reset() {
        this.contextList = []
        this.endOfList = false
        this.offset = 0
      },

      async setSubCategoryList(mainCode, subCode) {
        const { getCategoryMainData } = useHome()

        const data = await getCategoryMainData({ category: mainCode })

        if (data) {
          const { category } = data.layout
          const current = category.categoryList.find(
            (cate) => cate.code === mainCode,
          )

          const currentSub = current.subList.find(
            ({ code }) => code === subCode,
          )

          this.mainTitle = current.elementList[0].property.text
          const items = current.subList.map((sub) => {
            return {
              adult: 'n',
              title: sub.elementList[0].property.text,
              value: sub.code,
              eventlist: [convertEventOnClick(sub.elementList)],
            }
          })

          const mainHome = {
            adult: 'n',
            title: `${this.mainTitle} 홈`,
            value: this.$route.query.mainCode,
          }

          this.subList = {
            _default: currentSub.elementList[0].property.text,
            itemList: [mainHome, ...items],
          }

          this.setFilterValues()
        }
      },

      setFilterValues() {
        this.subCategoryList._default = this.subList._default
        this.subCategoryList.itemList = [...this.subList.itemList]
      },

      async fetchEventData(eventInstance) {
        if (this.isLoading) return
        this.isLoading = true

        if (!eventInstance) return

        const { query } = parseUrl(eventInstance.url)

        try {
          const { data } = await EventService.requestEventData(eventInstance)

          if (this.offset === 0) {
            this.titleList =
              (data.cell_toplist && data.cell_toplist.title_list) || []
            this.topButtonList =
              (data.cell_toplist && data.cell_toplist.topbuttonlist) || []

            this.thumbnailInfo = getBandTypeInfoByCellType(
              (data.cell_toplist && data.cell_toplist.cell_type) || '',
            )

            this.filterObject = data.filter || {}
            this.filterList = this.filterObject.filterlist || []
          }

          if (Object.keys(this.filterTitleMap).length === 0) {
            this.filterList.forEach((filterItem, index) => {
              const filterItemList = filterItem.filter_item_list || []
              filterItemList.forEach((item, itemIndex) => {
                const params = parse(item.api_parameters)
                const key = Object.keys(params)[0]

                if (query[key] === params[key]) {
                  this.filterQueryMap = { ...this.filterQueryMap, ...params }
                  this.filterTitleMap[index] =
                    (filterItemList[itemIndex] &&
                      filterItemList[itemIndex].title) ||
                    ''
                }
              })
              if (this.selectedCategoryTitle) {
                filterItemList.forEach((filterItem) => {
                  if (filterItem.title === this.selectedCategoryTitle) {
                    this.filterTitleMap[index] = filterItem.title
                  }
                })
              }
            })
          }

          const restContextList =
            (data.cell_toplist && data.cell_toplist.celllist) || []

          if (restContextList.length === 0) {
            this.endOfList = true
          }

          this.offset += this.limit
          this.contextList = [...this.contextList, ...restContextList]
          this.isLoading = false

          this.isEmpty = this.contextList.length === 0 // && restContextList.length === 0
        } catch (error) {
          this.isEmpty = true
          console.log('No data ', error)
        }
      },

      updateRouteKeepingMainAndSubCodeOnly() {
        const queryParams = { ...this.$route.query }
        const essentialKeys = ['mainCode', 'subCode']
        const newQuery = {}

        essentialKeys.forEach((key) => {
          if (queryParams[key]) {
            newQuery[key] = queryParams[key]
          }
        })

        this.$router.push({
          path: this.$route.path,
          query: newQuery,
        })
      },

      loadMore() {
        if (this.endOfList) return
        if (this.isUpdating) return

        const eventInstance = new EventModelClass(this.currentEvent)
        eventInstance.filter = this.filterQueryMap
        eventInstance.offset = this.offset
        eventInstance.limit = this.limit

        eventInstance.setPaging(true)
        this.fetchEventData(eventInstance)
      },

      handleBack() {
        this.$router.push({
          name: PATH_NAME_HOME,
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .overlay-portal {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .blur > div {
    -webkit-filter: blur(6px);
    filter: blur(6px);
    opacity: 0.7;
  }

  .filter-area {
    width: 100%;
    font-size: 14px;
    line-height: 40px;
    color: #fff;
    background-color: #1b1b1b;

    .filter-item-area {
      padding: 0 10px;
      font-size: 0;
      text-align: right;

      div {
        display: inline-block;
        margin-left: 14px;
        vertical-align: middle;
      }
    }
  }

  .view-more-editor-pick-header {
    width: 100%;
    box-sizing: border-box;
  }

  .empty-cell-list {
    position: relative;
    height: 250px;
    width: 250px;
    margin: 0 auto;
    top: 70px;

    .attention-mark-area {
      height: 50px;
      width: 50px;
      position: relative;
      margin: 0 auto;
    }

    .text-area {
      text-align: center;
      margin-top: 16px;
      color: #a5a5a5;
      font-size: 14px;
      line-height: 20px;
    }
  }

  .view-more-layout {
    position: relative;
    /*overflow-x: visible;*/
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 5000;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      display: none;
      background-color: transparent;
    }
  }

  .view-more-layout .view-more-component-container,
  .view-more-editor-component-container {
    width: 100%;
    position: relative;
    background-color: #1b1b1b;
  }

  .view-more-contents {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .view-more-component-container {
    &.fixed {
      position: fixed;
      margin: 0 !important;
      height: 100% !important;
      width: 100% !important;
    }
  }

  // 신규
  .inner {
    margin: 0 auto;
  }

  .top-section {
    height: 56px;
    padding-right: 12px;
  }

  .filter-wrapper {
    display: flex;
    justify-content: flex-end;
    margin: 0 2px;
    // height: 42px;
  }

  .orderby-area {
    .inner {
      padding: 12px 10px;
    }
  }
</style>
